/*/////////////FAQ非表示/////////////*/
$(function () {
  $(' ').hide();

  $('.#yes').on('click', function () {
    // クリックした要素の ID と違うクラス名のセクションを非表示
    $('.section').not($('.' + $(this).attr('id'))).hide();
    // クリックした要素の ID と同じクラスのセクションを表示
    $('.' + $(this).attr('id')).show(1000);

    // toggle にすると、同じボタンを 2 回押すと非表示になる
    $('.' + $(this).attr('id')).toggle();
  });
});

/*/////////////FAQアコーディオン/////////////*/

$(function () {
  $(".a__item").css("display", "none");

  $(".q__item").click(function () {

    $(".q__item").not(this).removeClass("open");

    $(".q__item").not(this).next().slideUp(300);

    $(this).toggleClass("open");

    $(this).next().slideToggle(300);
  });
});